import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Categories from "../components/Categories";
import WhyChoose from "../components/WhyChoose";
import PromoFooter from "../components/PromoFooter";
import Footer from "../components/Footer";

export default function Home() {
  const [showRegister, setShowRegister] = useState(false);

  const heroImage = "/biznep-mainsite/heroImage.webp";

  const promoImage =
    "https://media.base44.com/images/public/6aad7e262b745095045a824e/b8c55c379_generated_bef28b5b.jpg";

  return (
    <div className="min-h-screen bg-white">
      <Navbar onRegister={() => setShowRegister(true)} />

      <Hero
        heroImage={heroImage}
        showRegister={showRegister}
        onClose={() => setShowRegister(false)}
      />

      <Categories />
      <WhyChoose />
      <PromoFooter promoImage={promoImage} />
      <Footer />
    </div>
  );
}